export const BUZZ_SIGNAL_ORDER = ['reviews', 'media', 'footfall'];

export const BUZZ_SIGNAL_STYLES = {
  reviews: {
    textClass: 'text-n-teal-11',
    dotClass: 'bg-n-teal-9',
    fillClass: 'bg-n-teal-3',
    cssVar: '--teal-9',
  },
  media: {
    textClass: 'text-n-iris-11',
    dotClass: 'bg-n-iris-9',
    fillClass: 'bg-n-iris-3',
    cssVar: '--iris-9',
  },
  footfall: {
    textClass: 'text-n-ruby-11',
    dotClass: 'bg-n-ruby-9',
    fillClass: 'bg-n-ruby-3',
    cssVar: '--ruby-9',
  },
};

const FALLBACK_CHART_RGB = {
  reviews: '18 165 148',
  media: '91 91 214',
  footfall: '229 70 102',
};

export const buzzSignalStyle = key =>
  BUZZ_SIGNAL_STYLES[key] || BUZZ_SIGNAL_STYLES.reviews;

const readCssRgb = cssVar => {
  if (typeof document === 'undefined') return '';
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVar)
    .trim();
  return value;
};

export const buzzSignalChartColor = (key, alpha = 1) => {
  const style = buzzSignalStyle(key);
  const rgb = readCssRgb(style.cssVar) || FALLBACK_CHART_RGB[key];
  return alpha === 1 ? `rgb(${rgb})` : `rgba(${rgb}, ${alpha})`;
};

export const buzzSignalChartColors = (alpha = 1) =>
  BUZZ_SIGNAL_ORDER.map(key => buzzSignalChartColor(key, alpha));
